import { FC } from 'react';

import { AssetUtils } from '@ravago/shared/next-data-access';
import { NormalizedBlogPost } from '@ravago/shared/page-data/models/contentful-mapped';
import { BlogPreviewNode } from '@ravago/shared/page-data/models/elements';
import { AspectRatio } from '@ravago/shared/radiance/components/aspect-ratio/components/AspectRatio/AspectRatio';
import { Image } from '@ravago/shared/radiance/components/image/components/Image/Image';

interface Props {
   blogPost: NormalizedBlogPost;
   acceptWebp?: boolean;
   size: BlogPreviewNode['size'];
   zoomed?: boolean;
}

export const BlogPreviewImage: FC<Props> = ({ blogPost, acceptWebp, size, zoomed = false }) => (
   <AspectRatio desktop={size === 'normal' ? '3:2' : undefined} aspectRatio={size === 'normal' ? '21:9' : '16:9'} width="100%" useContainerQuery>
      <Image
         borderRadius="largest"
         src={AssetUtils.optimizeImageIfRequired(blogPost.image.url, acceptWebp, 1440)}
         alt={blogPost.title ?? ''}
         title={blogPost.title ?? ''}
         width="100%"
         height="100%"
         objectFit="cover"
         zoomed={zoomed}
      />
   </AspectRatio>
);
